// extracted by mini-css-extract-plugin
export default {"list":"list__Y2M2Z","item":"item__MDQ3M"};